const value = Object.freeze({
    Requests: 0,
    Books: 1,
    StudentsWithBooks: 2
  });
  export default value;
  